module.exports = __webpack_public_path__ + "static/img/pedals-gate.994798a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/pedals-gate.png
// module id = Wh3w
// module chunks = 12